import * as Joi from 'joi';

const schemaForgotPassword = Joi.object({
  dateOfBirth: Joi.string().required().messages({
    'any.required': 'Date of birth is not allowed to be empty.',
    'string.empty': 'Date of birth is not allowed to be empty.',
  }),
  username: Joi.string().required().max(50).messages({
    'any.required': 'Username is not allowed to be empty.',
    'string.empty': 'Username is not allowed to be empty.',
    'string.max': 'Username is too long.',
  }),
});

export default schemaForgotPassword;
